var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 2.25H5.60958C5.26651 2.25 4.98828 2.54288 4.98828 2.904V5.62613H10.332V2.25Z",
    fill: "#169154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98828 12.3955V15.0963C4.98828 15.4574 5.26651 15.7503 5.60922 15.7503H10.332V12.3955H4.98828Z",
    fill: "#18482A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98828 5.62598H10.332V9.00173H4.98828V5.62598Z",
    fill: "#0C8045"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98828 9.00195H10.332V12.3957H4.98828V9.00195Z",
    fill: "#17472A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0545 2.25H10.332V5.62613H15.6758V2.904C15.6758 2.54288 15.3975 2.25 15.0545 2.25Z",
    fill: "#29C27F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 12.3955V15.7503H15.0548C15.3975 15.7503 15.6758 15.4574 15.6758 15.0966V12.3959L10.332 12.3955Z",
    fill: "#27663F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 5.62598H15.6758V9.00173H10.332V5.62598Z",
    fill: "#19AC65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 9.00195H15.6758V12.3957H10.332V9.00195Z",
    fill: "#129652"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95095 12.75H2.02366C1.69306 12.75 1.4248 12.4676 1.4248 12.1196V5.88037C1.4248 5.53237 1.69306 5.25 2.02366 5.25H7.95095C8.28155 5.25 8.5498 5.53237 8.5498 5.88037V12.1196C8.5498 12.4676 8.28155 12.75 7.95095 12.75Z",
    fill: "#0C7238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49366 7.125H4.34367L5.03337 8.53275L5.76226 7.125H6.55634L5.4623 9L6.58128 10.875H5.74374L4.99205 9.40125L4.24357 10.875H3.39355L4.53106 8.99325L3.49366 7.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLogo);
export default __webpack_public_path__ + "static/media/fileLogo.63c51b9e45deb0fa58f3ba4faa236b58.svg";
export { ForwardRef as ReactComponent };